import { render, staticRenderFns } from "./PlayerSlider.vue?vue&type=template&id=45e4d02a&scoped=true&"
import script from "./PlayerSlider.vue?vue&type=script&lang=js&"
export * from "./PlayerSlider.vue?vue&type=script&lang=js&"
import style0 from "./PlayerSlider.vue?vue&type=style&index=0&id=45e4d02a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e4d02a",
  null
  
)

export default component.exports